import axios from "axios"

let baseURL = "https://admin.shipoe360.com/"; //生产环境,打包时一定要用这个地址 
//let baseURL = "http://10.80.100.224:7074/"; //生产环境,打包时一定要用这个地址 
// let baseURL = "http://10.29.35.129:7074/"; //生产环境,打包时一定要用这个地址
//let baseURL = "http://test.gxqhkj.com:8074/";// 本地项目用这个地址

const test = {
  post(url, data) {
    return axios.post(`${baseURL}${url}`,
    JSON.stringify(data),{
        headers: {
          "Content-Type": "application/json;charset=utf-8"
        }
      }
    )
  },
  delete(url, data) {
    return axios({
      method: 'delete',
      url: `${baseURL}${url}`,
      data: JSON.stringify(data),
      timeout: 1000,
      headers: {
        "Content-Type": "application/json;charset=utf-8"
      }
    })
  },
  put(url, data) {
    return axios({
      method: 'put',
      url: `${baseURL}${url}`,
      data: JSON.stringify(data),
      timeout: 1000,
      headers: {
        "Content-Type": "application/json;charset=utf-8"
      }
    })
  },
  get(url, data) {
    return axios.get(`${baseURL}${url}`,{
      params: data
    })
  },
}

export default test;